package kz.dentalcrm.app.screens.patients.detail.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface PatientDetailViewEvent : ViewEvent {

    data class LoadData(val id: Int): PatientDetailViewEvent

    data class UpdateName(val value: String) : PatientDetailViewEvent

    data class UpdateSurname(val value: String) : PatientDetailViewEvent

    data class UpdateBirthday(val value: String, val formatted: String) : PatientDetailViewEvent

    data class UpdatePhone(val value: String) : PatientDetailViewEvent

    data class UpdateIdn(val value: String) : PatientDetailViewEvent

    data class UpdateIdnNumber(val value: String) : PatientDetailViewEvent

    data class UpdateCity(val value: String) : PatientDetailViewEvent

    data class UpdateAddress(val value: String) : PatientDetailViewEvent

    data class UpdateWorkplace(val value: String) : PatientDetailViewEvent

    data class UpdatePosition(val value: String) : PatientDetailViewEvent

    data class UpdatePatronymic(val value: String) : PatientDetailViewEvent

    data class UpdateGender(val value: String) : PatientDetailViewEvent

    data object Delete : PatientDetailViewEvent

    data object Update : PatientDetailViewEvent
}